import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import "./SelectCaseType.scss";
import _ from "lodash";
import { useTranslation } from "react-i18next";

interface SelectProvidersProps {
  showModal: boolean;
  isAllSelected?: boolean;
  onCancel: () => void;
  onOk: () => void;
  selectProviderData?: [];
  selectScheduleData?: any;
  isMyScheduleClicked?: any;
  ListData?: any;
  getSelectedProviders: (data: any) => void;
  isFromStatusboard?: any;
  isFromCaseHistoryEdit?: boolean;
}

const SelectCaseType: React.FC<SelectProvidersProps> = (props) => {
    const { t } = useTranslation("statusBoard");
  var [isSelectProviderLoaderActive, setIsSelectProviderLoaderActive] =
    useState(true);

  var [isAllProvidersSelected, setIsAllProvidersSelected] = useState(false);
  var [isAnyProvidersSelected, setIsAnyProvidersSelected] = useState(true);
  var [selectProviderListData, SetSelectProviderListData]: any = useState([]);
  var [finalSelectProvidersList, setFinalSelectProvidersList]: any = useState(
    []
  );

  useEffect(() => {
    if (props.isFromStatusboard) {
      onCancelClicked();
    } else {
      SetSelectProviderListData(props.ListData);
    }
  }, [props.isFromStatusboard]);

  useEffect(() => {
    if (props.isFromCaseHistoryEdit) {
      const areAllProvidersInitiallySelected = props.ListData.every(
        (item: any) => item.is_selected === true
      );

      setIsAllProvidersSelected(areAllProvidersInitiallySelected);
    }
  }, []);

  const onCancelClicked = () => {
    if (!props.isFromCaseHistoryEdit) {
      const clearProviderList: Array<any> = [];
      props.ListData.map((item: any) => {
        item.is_selected = false;
        clearProviderList.push(item);
        props.onCancel();
      });
      SetSelectProviderListData(clearProviderList);
    } else {
      props.onCancel();
    }
  };

  const selectOrUnselectAllProviders = (
    checked: any,
    selectCaseListArray: any
  ) => {
    const selectedAllArray: Array<any> = [];
    selectCaseListArray.map((item: any) => {
      if (checked) {
        item.is_selected = true;
        setIsAnyProvidersSelected(true);
        setIsAllProvidersSelected(true);
        selectedAllArray.push(item);
      } else {
        item.is_selected = false;
        setIsAnyProvidersSelected(false);
        selectedAllArray.push(item);
      }
    });
    SetSelectProviderListData(_.cloneDeep(selectedAllArray));
  };

  const onCheckboxClicked = (isChecked: boolean, checkedItem: any) => {
    if (isChecked) {
      checkedItem.is_selected = true;
      setIsAnyProvidersSelected(true);
    } else {
      checkedItem.is_selected = false;
    }
    toggleSubmitButton();
  };

  // to enable/disable ok button and check/uncheck "All" checkbox
  const toggleSubmitButton = () => {
    const isAllProvidersSelected = props.ListData.every(
      (item: any) => item.is_selected === true
    );
    const isAnyProviderSelected = props.ListData.some(
      (item: any) => item.is_selected === true
    );
    if (isAllProvidersSelected) {
      setIsAllProvidersSelected(true);
      setIsAnyProvidersSelected(true);
    } else {
      setIsAllProvidersSelected(false);
    }
    if (!isAnyProviderSelected) {
      setIsAnyProvidersSelected(false);
    }
  };

  const submitFinalProvidersList = (arrayList: any) => {
    setFinalSelectProvidersList(_.cloneDeep(arrayList));
    //passing data to parent
    props.getSelectedProviders(arrayList);
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="ems-select-case-modal"
    >
      <IonItem>
        <IonLabel className="provider-label">Case types</IonLabel>
      </IonItem>
      <IonGrid className="scrollbar">
        <IonRow>
          <IonCol>
            <IonList className="items">
              {props.ListData.length ? (
                <div>
                  <IonItem lines="none">
                    <div slot="start" className="select-all-item"></div>
                    <div>
                      <IonCheckbox
                        className="check-box"
                        color="success"
                        id="select-all-checkbox"
                        slot="start"
                        checked={isAllProvidersSelected}
                        onClick={(e) =>
                          selectOrUnselectAllProviders(
                            e.currentTarget.checked,
                            props.ListData
                          )
                        }
                      />
                    </div>
                    <IonLabel>All</IonLabel>
                  </IonItem>
                </div>
              ) : null}
              {props.ListData && props.ListData.length
                ? props.ListData.map((item: any, index: number) => {
                    return [
                      <div className="provider-item-container">
                        <div className="provider-checkbox-div">
                          <IonItem lines="none" key={index}>
                            <div>
                              <IonCheckbox
                                className="check-box"
                                color="success"
                                slot="start"
                                onIonChange={(e) =>
                                  onCheckboxClicked(e.detail.checked, item)
                                }
                                checked={item.is_selected ? true : false}
                                value={item.case}
                              />
                            </div>
                            <IonLabel>{item.case}</IonLabel>
                          </IonItem>
                        </div>
                      </div>,
                    ];
                  })
                : !isSelectProviderLoaderActive && (
                    <div className="no-results-label">
                      No schedules to display
                    </div>
                  )}
            </IonList>
          </IonCol>
        </IonRow>
      </IonGrid>
      <div className="buttons-container-div">
        <IonItem lines="none">
          <IonButton
            slot="end"
            color="medium"
            className="cancel-button button secondary-btn  btn-curved"
            onClick={onCancelClicked}
          >
            {t("cancel")}
          </IonButton>
          <IonButton
            slot="end"
            className="submit-btn button primary-btn btn-curved"
            onClick={() => {
              submitFinalProvidersList(props.ListData);
              props.onOk();
            }}
          >
            Ok
          </IonButton>
        </IonItem>
      </div>
    </IonModal>
  );
};

export default SelectCaseType;
